export const merchantFaqData = [
  {
    tabHeader: "Receiving payments using your Trade card",
    tabContent: [
      {
        point: "What is the Pamo trade card?",
        detail:
          "It is your personalised, virtual shopping card on Pamo. Buyers use the funds on their trade card to negotiate with a merchant, as well as make payments. Merchants receive payment for the items they have delivered on their trade card. You can top up or withdraw from your trade card at any time.",
      },
      {
        section: "What are the balances below my trade card",
        points: [
          {
            point: "What are the balances below my trade card?",
            detail: [
              "There are two balances: your total balance and your available balance.",
              "Total balance is the total amount of funds on your trade card at any given time.",
              "Available balance: These are funds that are not locked to any deal or negotiation and are available to be withdrawn. The available balance will always be less than or equal to the total balance.",
              "The difference between your total balance and available balance is funds that are currently locked to pending transactions.",
            ],
          },
        ],
      },
      {
        point: "How do I add a payment type to my account?",
        detail:
          "Go to Profile, select Add Payment Type (below Trade card), and follow the prompts. The basic payment options are card, mobile money, and bank account. These may vary depending on your country.",
      },
      {
        point:
          "Can I receive payment for a product with my mobile money or card?",
        detail:
          "No. You can only receive payment onto your trade card. Once a customer accepts an offer or completes the 'Buy now' process, the amount will be added to your total balance.",
      },
      {
        point: "Can I withdraw funds from my trade card?",
        detail:
          "Yes, you can withdraw funds from your available balance to your mobile money or bank account at any time. Withdrawal is free.",
      },
      {
        point: "How do I withdraw from my Pamo trade card?",
        detail:
          'Go to "Pay Out" below the trade card. Select a payment method, enter the amount, and follow the approval process.',
      },
      {
        point: "When do I get paid as a merchant?",
        detail:
          "As soon as the buyer confirms delivery or a dispute is resolved in your favor, the amount is deposited into your Pamo trade card.",
      },
      {
        point: "How do I view my transactions?",
        detail:
          'Tap on "My Pamo" on the bottom bar to see your sales, purchases, top-ups and withdrawals.',
      },
      {
        point: "Are there charges for using Pamo?",
        detail:
          "We do not charge you for using the app. Your bank or mobile money provider may charge standard fees for transactions.",
      },
    ],
  },
  {
    tabHeader: "Making Offers on The Trade Feed",
    tabContent: [
      {
        point: "What is a trade feed?",
        detail:
          "It is the general view of the Pamo App where you find the list of posts made by buyers.",
      },
      {
        point: "How do I make an offer?",
        detail:
          "1. Tap the Make Offer button at the bottom of a post\n2. Choose to make the offer from inventory or manually\n3. Fill in details (price, condition, location, delivery mode)\n4. Add photos of the item\nNote: Only offer what was requested unless alternatives are specified.",
      },
      {
        point: "How do I view the offers I've made?",
        detail:
          'Go to "My Pamo" → "My Sales" → "Made Offers" or check your chatroom.',
      },
      {
        point: "Can I edit or delete an offer?",
        detail:
          "Yes, until the buyer reads the notification or engages with the offer. Once engaged, offers cannot be deleted.",
      },
    ],
  },
  {
    tabHeader: "Delivery",
    tabContent: [
      {
        point: "What are the delivery costs?",
        detail:
          "Costs depend on your preferred delivery option and distance. Motorbike deliveries are standard. Other transportation options cost more and can be arranged through Pamo.",
      },
      {
        point: "How does a customer confirm delivery?",
        detail:
          "After a deal is reached, they'll confirm in the chat room whether they received the correct items.",
      },
    ],
  },
  {
    tabHeader: "Warranty ",
    tabContent: [
      {
        point: "What happens if I’m unable to deliver?",
        detail:
          "You can cancel delivery in your chat room if you are unable to deliver. The post is then made available on the trade feed so that other merchants can make an offer to it.",
      },
    ],
  },
  {
    tabHeader: "Disputes ",
    tabContent: [
      {
        point: "A customer has raised a dispute. What does it mean?",
        detail:
          "It’s when a customer makes a claim that items were not delivered at all, or wrong/defective items were delivered. This claim can be seen in your chatroom with the customer and you can accept or deny the claim. If you accept the claim, the amount withheld for the deal is released to their available balance. If the you deny their claim, a dispute is raised.",
      },
      {
        point: "How is a dispute resolved?",
        detail:
          "A dispute is resolved after both parties come to an agreement. The buyer can opt to resolve the dispute in favour of the merchant and the funds will be released to the merchant’s available balance. The merchant can opt to resolve the dispute in favour of the buyer and the funds will be released to the buyer’s available balance. If both parties are unable to come to an agreement, they may request a mediator who will resolve the dispute. Requesting a mediator may come at a fee.",
      },
    ],
  },
  {
    tabHeader: "Account Management",
    tabContent: [
      {
        point: "How do I edit my profile?",
        detail:
          "Click the hamburger menu → profile image → follow prompts to update information.",
      },
      {
        section: "How do I become a verified business?",
        points: [
          {
            point: "How do I become a verified business?",
            detail: [
              "Sign up as a business",
              "Be legally registered in your country. ",
              " Go to Settings → 'Become a verified business'",
              " Submit required documents ",
              "Verified accounts get a purple badge.",
            ],
          },
        ],
      },
      {
        point: "How do I verify my account?",
        detail:
          "Provide:\n- Email\n- Business registration ID\n- Business registration certificate image\nVerification builds buyer trust and can boost sales.",
      },
      {
        point: "Where can I find my activity details?",
        detail:
          'In "My Pamo" you can view:\n• Done deals\n• Disputed offers\n• Pending deliveries\n• All transactions\n• Trade card balances\n• Fund statements',
      },
      {
        section: "",
        points: [
          {
            point: "How do I delete my account?",
            detail: [
              "To delete your account, tap the hamburger menu icon (☰) at the top left corner of your profile page, go to Settings, then select “Delete Account” – it’s the sixth option.",
              "Once selected, you will receive an email, and your account will be deactivated for 30 days. During this period, you can change your mind and reactivate it by simply logging back in. After 30 days, your account will be permanently deleted and cannot be recovered.",
            ],
          },
        ],
      },
    ],
  },
  {
    tabHeader: "The Store",
    tabContent: [
      {
        point: "What is the Store?",
        detail:
          "A feature that allows merchants to create and manage their inventory on Pamo, enabling automated offers.",
      },
      {
        point: "Can inventory be edited?",
        detail:
          "Yes. You can view, edit, update, or remove items from your inventory.",
      },
      {
        point: "Can I make offers from inventory?",
        detail:
          "Yes. You can choose to make offers manually or directly from your inventory.",
      },
      {
        point: "What can I do with the chat room?",
        detail:
          "• Answer customer questions\n• Close deals\n• Share photos/voice notes\n• Add catalogue photos",
      },
    ],
  },
  {
    tabHeader: "Rating & Reviews",
    tabContent: [
      {
        point: "What does merchant rating mean?",
        detail:
          "An average of all ratings (1-5) you've received from buyers, with 5 being best.",
      },
      {
        point: "Can customers leave ratings?",
        detail:
          "Yes. They can rate both products and their overall experience, including leaving comments.",
      },
      {
        point: "What are product ratings?",
        detail:
          "An average of all ratings for a specific product, shown with the total number of ratings in brackets.",
      },
    ],
  },
];
